<template>
  <div id="app" v-cloak>
    <!-- 公共commonBar -->
    <!-- <headerFixed v-if="!$route.meta.isShow"></headerFixed> -->
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <follow v-if="$route.meta.isPageShow"></follow>
    <!--全局代码刘海  -->
    <div class="agentNoticeBar" v-if="AgentIsShow == true">
      <div class="flex-between">
        <div style="display: flex">
          您正在为「
          <div class="ellipsisText ellipsisTextWidth">
            {{ agentShow.address.nickName }}
          </div>
          」代买
        </div>
        <div>
          <button class="cancelBuy agnetButton" @click="onCancelBuy">
            取消代买
          </button>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="close"
      showCancelButton
      confirmButtonText="是"
      cancelButtonText="否"
      cancelButtonColor="#9c9c9c"
      @confirm="onSubmit()"
      @cancel="close = false"
    >
      <div class="cancelAgent">是否取消代买</div>
    </van-dialog>
    <commonTabbar v-if="!$route.meta.isShow"></commonTabbar>
    <van-nav-bar
      v-if="$route.meta.navbar"
      :title="$route.meta.title"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <transition :name="transitionName"> -->
    <keep-alive key="alive">
      <router-view v-if="$route.meta.keepalive" />
    </keep-alive>
    <!-- :class="$route.meta.isShow?'':'isShowContent'" -->
    <router-view v-if="!$route.meta.keepalive" key="noalive" />
    <!-- </transition> -->
    <!-- 暂未对外开放   <access></access>-->

    <vue-progress-bar></vue-progress-bar>

    <div v-if="showEmpty">{{ emptyTitle }}</div>
    <van-tabbar
      v-if="$route.meta.tabbar"
      v-model="active"
      active-color="#f00"
      route
      :safe-area-inset-bottom="true"
    >
      <van-tabbar-item name="home" icon="home-o" to="/page" replace>
        <template #icon="props">
          <div v-if="props.active" class="tabberImg">
            <img src="../assets/images/homeActive.png" />
          </div>
          <div v-else class="tabberImg">
            <img src="../assets/images/sHome.png" />
          </div>
        </template>
        首页
      </van-tabbar-item>
      <!-- <img src="../assets/images/s6.png" alt=""> -->
      <van-tabbar-item name="packageList" to="/packageList" replace>
        <template #icon="props">
          <div v-if="props.active" class="tabberImg">
            <img src="../assets/images/packageActive.png" />
          </div>
          <div v-else class="tabberImg">
            <img src="../assets/images/sPacksge.png" />
          </div>
        </template>
        套餐
      </van-tabbar-item>
      <!-- <van-tabbar-item name="group" icon="search" to="/group" replace>分类</van-tabbar-item> -->
      <van-tabbar-item
        name="shoppingCart"
        icon="cart-o"
        to="/cart"
        :badge="cartQuantity"
        replace
      >
        <template #icon="props">
          <div v-if="props.active" class="tabberImg">
            <img src="../assets/images/cardActive.png" />
          </div>
          <div v-else class="tabberImg">
            <img src="../assets/images/sCard.png" />
          </div>
        </template>
        购物车
      </van-tabbar-item>
      <van-tabbar-item name="me" icon="user-o" to="/user" replace>
        <template #icon="props">
          <div v-if="props.active" class="tabberImg">
            <img src="../assets/images/userActive.png" />
          </div>
          <div v-else class="tabberImg">
            <img src="../assets/images/sUser.png" />
          </div>
        </template>
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<style>
.fix-position {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}
.van-overlay {
  z-index: 102;
}
#app {
  /* position: fixed; */
  width: 100%;
  height: 100%;
  /* height: 100vh; */
  /* overflow-x: hidden; */
  /* overflow-y: scroll; */
  /* padding-bottom: 15vh; */
  /* left: 0; */
  /* top: 0; */
  background: #f8f8f8;
}

/* 提示窗 */
.van-dialog {
  border-radius: 8px;
  color: #000;
}

.cancelAgent {
  min-height: 27.73333vw;
  line-height: 27.7333vw;
  text-align: center;
  font-size: 14px;
}

.isShowContent {
  margin-top: 50px;
}

/* 全局代买 */
.agentNoticeBar {
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  background: #ee0a25;
  color: #fff;
  /* 粘性定位 */
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
}

.activeButton {
  color: #fff;
  background: #ee0a25;
}

/* 取消购买 */
.agnetButton {
  border: 0;
  border-radius: 13px;
  padding: 0 8px;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  /* margin-left: 20px; */
}

.cancelBuy {
  background: #fff;
  color: #ee0a25;
}

.tabberImg {
  width: 22px;
  height: 22px;
}

.van-tabbar-item__icon img {
  height: 22px;
}

body {
  font-size: 14px;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>
<script>
import commonTabbar from "./components/commonTabbar/commonTabbar";
import follow from "./components/follow/index";
import {
  Tabbar,
  TabbarItem,
  NavBar,
  Toast,
  NoticeBar,
  Overlay,
  Dialog,
} from "vant";
import { mapGetters, mapActions } from "vuex";

import loading from "./components/loading/loading";
// import headerFixed from "./components/headerFixed/index.vue";
export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    commonTabbar,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
    loading,
    follow,
    // headerFixed
  },
  data() {
    return {
      close: false, //提示
      isLoading: true,
      active: 0,
      emptyTitle: "",
      showEmpty: false,
      // transitionName: "slide-left",
      isGoBack: false,
      historyRoute: null,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "cartInfo", "agentShow"]),
    cartQuantity() {
      return this.cartInfo == null ? "" : this.cartInfo;
    },
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },

  watch: {
    $route(to, from) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // this.$el.scrollTop = 0;
      if (from.path == "/") {
        // this.transitionName = "";
      } else if (!this.isGoBack) {
        // this.transitionName =
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scroll(0, 0);
        to.meta.menuindex < from.meta.menuindex ? "slide-right" : "slide-left";
      }
      // if (to.name == "orderdetail") {
      //   if (from.name == "myorder") {
      //     this.historyRoute = from;
      //   } else {
      //     this.historyRoute = {
      //       name: "myorder",
      //       params: { orderStatusId: 0 }
      //     };
      //   }
      // }

      if (to.name == "page") {
        // console.log(1111111)
      } else {
        // console.log(222222222222)
        this.$nextTick(() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scroll(0, 0);
        });
      }
      console.log(document.documentElement.scrollTop, document.body.scrollTop);
      this.isGoBack = false;
    },
  },

  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    let HOST = process.env.HOST;
    process.argv.forEach((val, index) => {
      console.log(`${index}: ${val}`);
    });
    this.$Progress.finish();

    this.isLoading = false;
  },
  methods: {
    ...mapActions(["updateUserCartQuantity", "buyAgentStatus"]),
    // 确定存起来
    onSubmit() {
      this.buyAgentStatus({ show: false });
    },
    // 取消代买
    onCancelBuy() {
      this.close = true;
    },
    onClickLeft() {
      // if (this.historyRoute != null) {
      //   this.$router.replace({
      //     name: this.historyRoute.name,
      //     params: this.historyRoute.params
      //   });
      //   this.historyRoute = null;
      // } else {

      this.$router.go(-1);

      // this.transitionName = "slide-right";
      this.isGoBack = true;
    },
  },
};
</script>
